(() => {
  const body = document.body;
  if (!body.classList.contains('sm-creative')) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const progress = document.createElement('div');
  progress.className = 'sm-scroll-progress';
  progress.setAttribute('aria-hidden', 'true');
  body.appendChild(progress);
  let scrollFrame = 0;
  const updateScroll = () => {
    scrollFrame = 0;
    const distance = document.documentElement.scrollHeight - window.innerHeight;
    progress.style.setProperty('--sm-progress', distance > 0 ? Math.min(1, Math.max(0, window.scrollY / distance)) : 0);
    body.classList.toggle('sm-scrolled', window.scrollY > 28);
  };
  window.addEventListener('scroll', () => {
    if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScroll);
  }, { passive: true });
  window.addEventListener('resize', updateScroll, { passive: true });
  updateScroll();
  let pointerFrame = 0;
  let activeCard = null;
  let pending = null;
  const reset = card => {
    if (!card) return;
    for (const name of ['--sm-rx', '--sm-ry', '--sm-x', '--sm-y']) card.style.removeProperty(name);
  };
  body.addEventListener('pointermove', event => {
    if (!fine.matches || reduced.matches || event.pointerType === 'touch') return;
    const card = event.target instanceof Element ? event.target.closest('.card-wrapper') : null;
    if (activeCard !== card) reset(activeCard);
    activeCard = card;
    if (!card) return;
    pending = { card, x: event.clientX, y: event.clientY };
    if (pointerFrame) return;
    pointerFrame = requestAnimationFrame(() => {
      pointerFrame = 0;
      const point = pending;
      if (!point || point.card !== activeCard || !point.card.isConnected) return;
      const rect = point.card.getBoundingClientRect();
      const x = Math.max(0, Math.min(1, (point.x - rect.left) / rect.width));
      const y = Math.max(0, Math.min(1, (point.y - rect.top) / rect.height));
      point.card.style.setProperty('--sm-x', `${x * 100}%`);
      point.card.style.setProperty('--sm-y', `${y * 100}%`);
      point.card.style.setProperty('--sm-rx', `${(0.5 - y) * 1.2}deg`);
      point.card.style.setProperty('--sm-ry', `${(x - 0.5) * 1.2}deg`);
    });
  }, { passive: true });
  const resetPointer = () => { reset(activeCard); activeCard = null; };
  document.addEventListener('pointerleave', resetPointer);
  window.addEventListener('blur', resetPointer);
  reduced.addEventListener('change', resetPointer);
  const galleryRecords = new WeakMap();
  const setupGallery = track => {
    if (galleryRecords.has(track)) return;
    const buttons = Array.from(document.querySelectorAll('[data-sm-gallery-direction]')).filter(button => button.getAttribute('aria-controls') === track.id);
    const update = () => {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      const offset = Math.min(maximum, Math.abs(track.scrollLeft));
      buttons.forEach(button => {
        button.disabled = Number(button.dataset.smGalleryDirection) < 0 ? offset <= 1 : offset >= maximum - 1;
      });
    };
    const move = direction => {
      const flow = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      track.scrollBy({ left: track.clientWidth * 0.85 * direction * flow, behavior: reduced.matches ? 'auto' : 'smooth' });
    };
    buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.smGalleryDirection))));
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      const behavior = reduced.matches ? 'auto' : 'smooth';
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        track.scrollBy({ left: track.clientWidth * 0.85 * (event.key === 'ArrowRight' ? 1 : -1), behavior });
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        const flow = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
        track.scrollTo({ left: event.key === 'Home' ? 0 : flow * track.scrollWidth, behavior });
      }
    });
    track.addEventListener('load', update, true);
    const resize = 'ResizeObserver' in window ? new ResizeObserver(update) : null;
    resize?.observe(track);
    if (track.firstElementChild) resize?.observe(track.firstElementChild);
    galleryRecords.set(track, { resize });
    update();
  };
  const observed = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!reduced.matches) entry.target.classList.add('sm-entered');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12 }) : null;
  const enhance = root => {
    root.querySelectorAll('[data-sm-scroll-gallery]').forEach(setupGallery);
    if (!observer) return;
    root.querySelectorAll('.collection-hero__title').forEach(element => {
      if (observed.has(element)) return;
      observed.add(element);
      observer.observe(element);
    });
  };
  enhance(document);
  document.addEventListener('shopify:section:load', event => { enhance(event.target); updateScroll(); });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-sm-scroll-gallery]').forEach(track => galleryRecords.get(track)?.resize?.disconnect());
    event.target.querySelectorAll('.collection-hero__title').forEach(element => observer?.unobserve(element));
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) resetPointer(); });
})();
